import React from "react";
import moment from "moment";

import colours from '../../../../../../Common/DesignSystem/Colours';
import Icon from "../../../../../../Common/DesignSystem/Icons/Icon";

export const VehicleLastBookingCell = ({ lastBookingDate }) => (
    <>
        <Icon name="UsageActive" size={24} style={{ marginRight: 4, color: colours.accent.validate_green}}/>
        {moment(lastBookingDate).format('MMM DD, YYYY')}
    </>
);
